import script from "./benefitsPurchase.vue?vue&type=script&setup=true&lang=ts"
export * from "./benefitsPurchase.vue?vue&type=script&setup=true&lang=ts"

import "./benefitsPurchase.vue?vue&type=style&index=0&id=37048bc0&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-37048bc0"]])

export default __exports__